import { render } from "./Search.vue?vue&type=template&id=360783da"
import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Sixtran/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "360783da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('360783da', __exports__)) {
    api.reload('360783da', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=360783da", () => {
    api.rerender('360783da', render)
  })

}


export default __exports__